import { Injectable } from '@angular/core';

import { TypedDialogService } from '@libs/src/typed-dialog/typed-dialog.service';

import { ProfileMessageDialogComponent } from '@main-client/src/app/profile/profile-message-dialog/profile-message-dialog.component';

import { ProfileMessageDialogConfig } from '@main-client/src/app/profile/profile-message-dialog/profile-message-dialog';

@Injectable()
export class ProfileMessageDialogService {
  constructor(private readonly dialog: TypedDialogService) {}

  openDialog({
    analyticNameSuffix,
    message,
    profile,
    user,
    origin,
  }: ProfileMessageDialogConfig) {
    return this.dialog
      .open(ProfileMessageDialogComponent, {
        disableClose: true,
        data: { analyticNameSuffix, message, profile, origin, user },
        maxWidth: '500px',
        width: '95vw',
      })
      .afterClosed();
  }
}
